import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { investmentService } from '../services/api';

function Investments() {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInvestments();
  }, []);

  const loadInvestments = async () => {
    try {
      const data = await investmentService.index();
      setInvestments(data.data || data || []);
    } catch (error) {
      console.error('Error loading investments:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900">Ortus</Link>
          <div className="flex gap-4">
            <Link to="/shop" className="text-blue-600">Shop</Link>
            <Link to="/login" className="text-blue-600">Login</Link>
          </div>
        </div>
      </nav>

      <main className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">Investment Opportunities</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {investments.map((inv) => (
            <div key={inv.id} className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-1">{inv.title}</h3>
              <p className="text-sm text-gray-600 mb-2">{inv.description}</p>
              <div className="flex justify-between text-sm">
                <span className="font-medium">Target: ${inv.target_amount}</span>
                <span className="font-medium">ROI: {inv.expected_roi}%</span>
              </div>
              <span className={`inline-flex text-xs leading-5 font-semibold rounded-full px-2 py-1 mt-2 ${inv.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>{inv.status}</span>
            </div>
          ))}
        </div>
        {investments.length === 0 && <p className="text-gray-500 mt-4">No investment opportunities currently.</p>}
      </main>
    </div>
  );
}

export default Investments;
